import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import {
    contactHero,
    heroImg,
    headBasic,
    doFlex,
    flexColumn,
    divW50,
    marR2,
    pad4em,
    container,
    justifySpaceBetween,
    topContact,
    offices,
} from '../components/main.module.scss'
import Layout from "../components/layout";
import { SEO } from "../components/seo";
import Section from "../components/section";
import ContactDepartments from "../components/contactdepartments";
import Knowmore from "../components/knowmore";

const Contactus = () => {
    return (
        <Layout>
            <div >
                <div className={contactHero}>
                    <div className={`${doFlex} ${container} ${justifySpaceBetween}`}>
                        <div className={`${doFlex} ${flexColumn} ${divW50} ${marR2} ${pad4em}`}>
                            <h1 className={headBasic}>Contact Us</h1>
                            <p>We are committed to offering excellent services and support. If you require help, do not hesitate to contact us.</p>

                            <div className={topContact}>
                                <div className={offices}>
                                    <h3>Corporate Office</h3>
                                    <p>BigBox Softwares LLC <br /> 4001 Tordera Drive <br />Austin, TX-78738 <br />USA</p>
                                </div>
                                <div className={offices}>
                                    <h3>Regional Office</h3>
                                    <p>BigBox Networks Inc. <br /> 325 Front St W Suite 300 <br />Toronto, ON M5V 2Y1 <br />Canada</p>
                                </div>
                                <div className={offices}>
                                    <h3>Branch Office</h3>
                                    <p>BigBox Infosoft LLP <br /> T53-2601, Amanora Park Town<br />Pune, Maharashtra - 411028<br />India</p>
                                </div>
                            </div>

                        </div>
                        <div className={heroImg}>
                            <StaticImage src="../images/contactus.png" alt="BigBox Office" layout="constrained" quality="100" />
                        </div>
                    </div>
                </div>
                <Section sectionName="Connect to department specific teams">
                    <ContactDepartments></ContactDepartments>
                </Section>
                <Knowmore></Knowmore>

            </div>
        </Layout>
    );
}


export default Contactus;

export const Head = () => (
    <SEO title="Get in Touch with BigBoxHost - Contact Us"
    description="Reach out to us for reliable hosting solutions. Contact our teams for any inquiries, assistance, and information about our services."
    pathname="/contact-us/"
    />
)
